import 'zone.js';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

const SPLASH_MIN_MS = 1500;
const t0 = performance.now();

bootstrapApplication(App, appConfig)
  .then(() => {
    const elapsed = performance.now() - t0;
    const wait = Math.max(0, SPLASH_MIN_MS - elapsed);

    setTimeout(() => {
      const splash = document.getElementById('splash');
      if (!splash) return;
      splash.classList.add('splash--hidden');

      setTimeout(() => splash.remove(), 400);
    }, wait);
  })
  .catch(err => console.error(err));
